export const environment = {
  production: false,
  apiUrl: 'https://cmgsvcgdocsbulkexportapiappqa01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '9e6f0d0b-3db7-4fe9-9906-319a36d04652',
      authority:
        'https://login.microsoftonline.com/57d88166-f247-4dee-a6f9-e6359f96ff2c',
    },
    apiScope: 'api://fbca35a4-58d2-439d-a65f-b126bd1a5f3d/adminapiscope',
    graphScope: 'user.read',
    graphUri: 'https://graph.microsoft.com/v1.0/',
  },
  enablePhase2: true,
  defaultServiceProviderGuid: '6f85a78e-f7c6-4fb4-9789-52fc16d71e3f',
};
